document.addEventListener('DOMContentLoaded', function () {
  // --------- Compte à rebours (inchangé)
  function bindTimers(root){
    (root||document).querySelectorAll('.preorder-timer:not([data-bound])').forEach(function(el){
      el.setAttribute('data-bound','1');
      var startISO = el.getAttribute('data-start');
      var endISO   = el.getAttribute('data-end');
      if(!endISO) return;
      var start = startISO ? Date.parse(startISO) : Date.now();
      var end   = Date.parse(endISO);
      if(isNaN(end)) return;

      var out = el.querySelector('.preorder-timer__countdown');
      function fmt(n){ return (n<10?'0':'')+n; }
      function tick(){
        var now = Date.now();
        var remain = Math.max(0, end - now);
        if(!out) return;

        if(remain === 0){
          out.innerHTML = '<span class="preorder-timer__label">Bientôt disponible</span>';
          return;
        }
        var s = Math.floor(remain/1000);
        var j = Math.floor(s/86400); s%=86400;
        var h = Math.floor(s/3600);  s%=3600;
        var m = Math.floor(s/60);    s%=60;

        out.innerHTML =
          '<span class="preorder-timer__label">Arrive dans:</span> '+
          '<span class="preorder-timer__count">'+
          j+'j '+fmt(h)+'h '+fmt(m)+'m '+fmt(s)+'s</span>';
      }
      tick();
      setInterval(tick, 1000);
    });
  }
  bindTimers(document);
  new MutationObserver(()=>bindTimers(document)).observe(document.documentElement,{childList:true,subtree:true});

  // --------- Limite effective pour +/− (identique à custom-collection.js)
  function getLimitForPlus(card){
    const isPre = String(card.getAttribute('data-preorder-live')) === 'true';
    const stock = parseInt(card.getAttribute('data-max-quantity') || '0', 10);
    const cap   = parseInt(card.getAttribute('data-preorder-cap') || '0', 10);
    if (isPre && stock <= 0) return cap > 0 ? cap : 999999; // préco sans cap = quasi illimité côté front
    return stock;
  }


  // --------- Step d'incrément et alignement
  function getStep(card){
    const s = parseInt(card.getAttribute('data-step') || '1', 10);
    return isNaN(s) || s < 1 ? 1 : s;
  }

  function clampToStep(val, step){
    val = parseInt(val || '0', 10);
    if (isNaN(val) || val < 0) val = 0;
    return Math.floor(val / step) * step;
  }


// --- Affichage de la note "rouleau de 10" pour le type Nicotine Pouches
function updateRollNote(card){
  if(!card) return;
  const type = (card.getAttribute('data-type') || '').toLowerCase();
  if(type !== 'nicotine-pouches') return;   

  const input = card.querySelector('.quantity-input');
  const note  = card.querySelector('.roll-note');
  if(!input || !note) return;

  const val = parseInt(input.value || '0', 10) || 0;
  note.style.display = val > 0 ? 'block' : 'none';
}

// 2) After DOM is ready, do an initial sync (in your DOMContentLoaded handler)
document.querySelectorAll('.product-card').forEach(updateRollNote);




// --------- Bouton + (CORRIGÉ avec step)
  document.addEventListener('click', function (e) {
    const plus = e.target.closest('.plus-btn');
    if (!plus) return;

    const card = plus.closest('.product-card');
    const input = card.querySelector('.quantity-input');
    const current = parseInt(input.value) || 0;
    const limitForPlus = getLimitForPlus(card);
    const step = getStep(card);

    let next = current + step;

    if (next > limitForPlus) {
      // Si on dépasse, on aligne sur le multiple inférieur
      if (step > 1) {
        next = clampToStep(limitForPlus, step);
      } else {
        next = limitForPlus;
      }
      const isPre = String(card.getAttribute('data-preorder-live')) === 'true';
      if (current >= next) {
        alert(isPre
          ? "Vous avez atteint la quantité maximale de pré-commande."
          : "Vous ne pouvez pas ajouter d'autres articles au panier."
        );
        return;
      }
    }

    input.value = next;

    updateAddButtonState(
      card.getAttribute('data-variant-id'),
      card.getAttribute('data-max-quantity')
    );
    updateRollNote(card);
  });



  // --------- Bouton − (CORRIGÉ avec step)
  document.addEventListener('click', function (e) {
    const minus = e.target.closest('.minus-btn');
    if (!minus) return;

    const card = minus.closest('.product-card');
    const input = card.querySelector('.quantity-input');
    const current = parseInt(input.value) || 0;
    const step = getStep(card);

    let next = current - step;
    if (next < 0) next = 0;

    input.value = next;

    updateAddButtonState(
      card.getAttribute('data-variant-id'),
      card.getAttribute('data-max-quantity')
    );
    updateRollNote(card);
  });


  // --------- Saisie clavier bornée (CORRIGÉ avec clampToStep)
  document.addEventListener('input', function(e){
    const input = e.target.closest('.quantity-input');
    if(!input) return;
    const card = input.closest('.product-card');
    if(!card) return;

    const isPre = String(card.getAttribute('data-preorder-live')) === 'true';
    const stock = parseInt(card.getAttribute('data-max-quantity') || '0', 10);
    const cap   = parseInt(card.getAttribute('data-preorder-cap') || '0', 10);
    const step  = getStep(card);

    let max = stock;
    if (isPre && stock <= 0) { max = cap > 0 ? cap : 999999; }

    // Aligner la saisie sur le multiple du step
    let val = clampToStep(input.value, step);
    if (val > max) val = clampToStep(max, step);
    input.value = String(val);

    updateAddButtonState(
      card.getAttribute('data-variant-id'),
      card.getAttribute('data-max-quantity')
    );
    updateRollNote(card);
  });

  // --------- Mise à jour du bouton "Ajouter" (exacte à collection)
  function updateAddButtonState(variantId, maxQuantity) {
    const quantityInput = document.querySelector('[data-variant-id="' + variantId + '"] .quantity-input');
    const currentQuantity = parseInt(quantityInput?.value) || 0;
    const addButton = document.querySelector('[data-variant-id="' + variantId + '"] .add-button');
    if (!addButton) return; // si carte en précommande: pas de bouton "Ajouter"
    const stockMax = parseInt(maxQuantity || '0', 10);
    addButton.disabled = currentQuantity > stockMax;
  }

  // --------- Ajout au panier (on garde Shopify.addItem)
  document.addEventListener('click', function(e){
    const addBtn = e.target.closest('.add-button');
    if(!addBtn) return;

    const card = addBtn.closest('.product-card');
    const variantId = card.getAttribute('data-variant-id');
    const quantity = parseInt(card.querySelector('.quantity-input').value) || 0;
    if (quantity > 0) addToCart(variantId, quantity, addBtn, card);
  });

function addToCart(variantId, quantity, addButton, card) {
  addButton.textContent = '...';
  const group = card.getAttribute('data-limit-group');

  if (group) {
    const body = new URLSearchParams();
    body.append('id', variantId);
    body.append('quantity', quantity);
    body.append('properties[_limit_group]', group);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: body.toString()
    })
    .then(r => r.ok ? r.json() : Promise.reject(r))
    .then(() => afterAdd())
    .catch(() => fail());
  } else {
    Shopify.addItem(variantId, quantity, function () { afterAdd(); });
  }

  function afterAdd(){
    addButton.innerHTML = '<span class="checkmark-icon"><svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M7.5 10l3 3 7-7" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

    const input = card.querySelector('.quantity-input');
    if (input) input.value = 0;
    if (typeof updateRollNote === 'function') updateRollNote(card);

    if (window.Shopify && typeof Shopify.getCart === 'function') Shopify.getCart();
    document.dispatchEvent(new CustomEvent('cart:updated'));

    setTimeout(() => { addButton.textContent = 'Ajouter'; }, 1200);
  }

  function fail(){
    alert("Erreur d'ajout au panier");
    addButton.textContent = 'Ajouter';
  }
}


  // --------- Bouton "Pré-Commander" (ajout propre des propriétés checkout)
  if(!window.__bindPreorderPDP){
    window.__bindPreorderPDP = true;
    document.addEventListener('click', function(e){
      const btn = e.target.closest('.btn-preorder'); if(!btn) return;
      e.preventDefault();

      const card = btn.closest('.product-card');
      const variantId = card.getAttribute('data-variant-id');
      const qty = parseInt(card.querySelector('.quantity-input')?.value || '1', 10) || 1;

      const isPre = String(card.getAttribute('data-preorder-live')) === 'true';
      const stock = parseInt(card.getAttribute('data-max-quantity') || '0', 10);
      const cap   = parseInt(card.getAttribute('data-preorder-cap') || '0', 10);
      if (isPre && stock <= 0 && cap > 0 && qty > cap) {
        alert("Vous avez atteint la quantité maximale de pré-commande.");
        return;
      }

      const original = btn.textContent;
      btn.textContent = '...'; btn.disabled = true;

      const body = new URLSearchParams();
      body.append('id', variantId);
      body.append('quantity', qty);

      // Propriété lisible au checkout
      const end = btn.getAttribute('data-end'); // YYYY-MM-DD
      const msg = btn.getAttribute('data-shipping-msg') || 'Arrivage estimé';
      if (end) {
        const d = new Date(end + 'T00:00:00');
        const pretty = d.toLocaleDateString('fr-FR',{day:'2-digit',month:'short',year:'numeric'}).replace(/\./g,'');
        body.append('properties[📦 ' + msg + ']', pretty);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: body.toString(),
      })
      .then(r => r.ok ? r.json() : Promise.reject(r))
      .then(function(){
        const input = card.querySelector('.quantity-input');
        if (input) input.value = 0;
        updateRollNote(card);

        if (window.Shopify && typeof Shopify.getCart === 'function') Shopify.getCart();
        try{
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (window.theme?.cart?.refresh) theme.cart.refresh();
          if (window.CartDrawer?.refresh)  CartDrawer.refresh();
          if (window.Minicart?.update)     Minicart.update();
        }catch(_){}

        // Feedback visuel après succès PRECO
        btn.innerHTML =
        '<span class="checkmark-icon"><svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M7.5 10l3 3 7-7" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

        setTimeout(function(){ btn.textContent = original; btn.disabled = false; }, 1200);
      })
      .catch(function(){
        alert("Erreur d'ajout au panier");
        btn.textContent = original; btn.disabled = false;
      });
    });
  }

  // Toggle description
  const descriptionHeader = document.querySelector('.description-header');
  const descriptionContent = document.querySelector('.description-content');
  const toggleIcon = descriptionHeader?.querySelector('.toggle-icon');

  if (descriptionHeader) {
    descriptionHeader.addEventListener('click', () => {
      descriptionContent.classList.toggle('visible');
      descriptionHeader.classList.toggle('open');
    });
  }
});


